const pageSpacingConfig = {
	xs: {
		xxs: 'var(--spacing-page-xxs)',
		m: 'var(--spacing-page-xs)',
		l: 'var(--spacing-page-xs)',
	},

	s: {
		xxs: 'var(--spacing-page-xs)',
		m: 'var(--spacing-page-s)',
		l: 'var(--spacing-page-s)',
	},

	m: {
		xxs: 'var(--spacing-page-s)',
		m: 'var(--spacing-page-m)',
		l: 'var(--spacing-page-m)',
	},

	l: {
		xxs: 'var(--spacing-page-m)',
		m: 'var(--spacing-page-l)',
		l: 'var(--spacing-page-l)',
	},

	xl: {
		xxs: 'var(--spacing-page-xl)',
		m: 'var(--spacing-page-xl)',
		l: 'var(--spacing-page-xl)',
	},
};

export default pageSpacingConfig;
